import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AgentsService} from "../../services/agents-service.service";
import {ItinerariesService} from "../../../itineraries/services/itineraries-service.service";
import {$agentsFactory} from "../../$agents.factory";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../../tasks/models/task.model";

export class ItinerariesTimelineViewCtrl implements IController {

  agentIds: any;
  agentsGroup: any;
  branchIds: any;
  agentSkills: any;
  queryString: any;

  tasks: any;

  private SITE_ID: any;
  private tasksRef: any;
  private tasksRefList: any;
  private itineraries: any;
  private itinerariesRefList: any;
  private filtersConfig: any;
  private size: any;
  private page: any;

  private pagenationPages: any;

  private from: any;
  private to: any;

  constructor(private $agents: $agentsFactory, private itinerariesService: ItinerariesService, private moment, private $itineraries, private $task,
              private agentsService: AgentsService, private splitService: SplitService, private tasksService: TasksService, private $scope: IScope) {
  }

  $onInit() {
    this.SITE_ID = this.splitService.getSiteId();
    this.tasksRef = this.$task();
    this.tasksRefList = [];
    this.tasks = [];

    this.from = this.moment().subtract(3, 'hour').valueOf();
    this.to = this.moment().endOf('day');

    // this.from = this.moment().startOf('day').valueOf();
    // this.to = this.moment().startOf('day').add(7, 'day').valueOf();

    this.itineraries = undefined; // Loading On when undefined
    this.itinerariesRefList = [];

    this.size = 10;
    this.page = 0;

    this._initItineraries();
  };

  $onChanges(changes) {
    if ((changes.agentsGroup && !changes.agentsGroup.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange())) {

      this._initItineraries();
    }
  };

  $onDestroy() {
    if (this.itinerariesRefList.length) {
      this._destroyItinerariesBindings();
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  isPaginationItemSelected(pageIndex) {
    return _.get(this.itineraries, 'pageable.pageNumber') === pageIndex;
  }

  onPaginationBrowse(isNext) {
    this.page = isNext ? (this.page + 1) : (this.page - 1);
    this._initItineraries();
  }

  onPaginationChange(pageIndex) {
    this.page = pageIndex;
    this._initItineraries();
  }

  onAgentsGroupChange(agentsGroup) {
    this.agentsGroup = agentsGroup;
    this.splitService.setSiteItinerarySettings( {agentsGroup: agentsGroup});
    this.page = 0;

    this._initItineraries();
  }

  onShowTaskTooltip(task, $event) {

  }

  // ******************************
  //        Private methods
  // ******************************

  private _initItineraries() {
    const group = this.agentsGroup;
    const queryPayload = {
      ids: this.agentIds,
      query: this.queryString,
      status: undefined,
      group: undefined,
      sortByLoad : true,
      branchIds: this.branchIds || [],
      skill: this.agentSkills,
      size: this.size,
      page: this.page
    };

    if (!!group) {
      if (_.isEqual(group, 'Active')) {
        queryPayload.group = group;
      }
      if (_.isEqual(group, 'OffDuty')) {
        queryPayload.status = group;
      }
    }

    this.agentIds = undefined;

    if (this.itineraries) {
      this.itineraries.content = [];
    }
    this.tasks = [];

    this.itinerariesService.getPageableItineraries(queryPayload)
      .then((itineraries) => {
        this.itineraries = itineraries;
        this.pagenationPages = _.range(itineraries.totalPages);
        this._bindItineraries(itineraries.content);
      })
  }

  private _bindItineraries(itineraries) {

    if (this.itinerariesRefList.length) {
      this._destroyItinerariesBindings();
    }

    this.itinerariesRefList = [];

    if(itineraries && itineraries.length) {
      const itinerariesWithIds = _.filter(itineraries, 'id'); // TODO Remove its a quick fix for itineraries that doesnt have ids

      _.forEach(itinerariesWithIds, (itinerary) => {
        const id = itinerary.id;
        const itineraryRef = this.$itineraries(id);
        this.itinerariesRefList.push(itineraryRef);

        this._bindTasks(itinerary.taskIdListExt);

        itineraryRef.$bindCtrl(this.$scope, this, id);
        itineraryRef.$registerOnUpdateHandler(this.$scope,(updatedItinerary) => {

          if (_.isEqual(updatedItinerary.id, id)) {
            const itineraryIndexToUpdate = _.findIndex(this.itineraries.content,(i:any) => {
              return i.id === updatedItinerary.id;
            });
            if (itineraryIndexToUpdate > -1) {
              this._updateItineraryTasks(this.itineraries.content[itineraryIndexToUpdate].taskIdListExt, updatedItinerary.taskIdListExt);
              let itinerariesCopy = angular.copy(this.itineraries.content);
              itinerariesCopy[itineraryIndexToUpdate] = updatedItinerary;
              this.itineraries.content = itinerariesCopy;
            } else {
              // locationRef.$destroy();
            }
          }

        });
      })

    }
  }

  private _destroyItinerariesBindings() {
    _.forEach(this.itinerariesRefList, (itineraryObjectRef) => {
      itineraryObjectRef.$destroy();
    });
  }

  private _destroyTasksBindings(ids) {
    _.forEach(ids,(id) => {
      if (this.tasksRefList[id]) {
        this.tasksRefList[id].$destroy();
        _.unset(this.tasksRefList, id);
      }
    });
  }



  private _updateItineraryTasks(oldTaskIds, updatedTaskIds) {
    let taskIdsToRemove = _.difference(oldTaskIds, updatedTaskIds);
    let taskIdsToAdd = _.difference(updatedTaskIds, oldTaskIds);

    if (taskIdsToRemove.length) {
      this._destroyTasksBindings(taskIdsToRemove);
      this.tasks = _.filter(this.tasks, (t) => {
        return !_.includes(taskIdsToRemove, t.id);
      })
    }
    if (taskIdsToAdd.length) {
      this._bindTasks(taskIdsToAdd);
    }
  }

  private _bindTasks(taskIds) {

    if (_.isUndefined(taskIds)) {
      taskIds = [];
    }

    this.tasksRef.$asyncValues(taskIds)
      .then((tasksToAdd) => {
        this.tasks = this.tasks.concat(tasksToAdd);

        _.forEach(tasksToAdd, (task: TaskModel) => {
          const taskRef = this.$task(task.id);
          this.tasksRefList[task.id] = taskRef;

          // let isInit = true;
          // taskRef.$bindCtrl(this.$scope, this, task.id);
          // taskRef.$registerOnUpdateHandler(this.$scope, (updatedTask) => {
          //   if (_.isEqual(updatedTask.id, task.id)) {
          //     const taskIndex = _.findIndex(this.tasks, (t: any) => {
          //       return t.id === updatedTask.id;
          //     })
          //     if (taskIndex > -1) {
          //       const tasksCopy = angular.copy(this.tasks);
          //       tasksCopy[taskIndex] = updatedTask
          //       this.tasks = tasksCopy;
          //     }
          //
          //   }
          // });

        })
      })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsItinerariesTimelineView', {
    bindings: {
      agentIds : '<',
      agentsGroup: '<?',
      branchIds: '<',
      agentSkills: '<?',
      queryString: '<?'
    },
    template: require('./agents-itineraries-timeline-view.html').default,
    controller: ItinerariesTimelineViewCtrl
  });
